const Card = ({ children, style, className, ...props }) => {
  const cardStyle = {
    background: '#fff',
    borderRadius: '25px',
    padding: '15px',
    ...style,
  };

  return (
    <div style={cardStyle} className={className} {...props}>
      {children}
    </div>
  );
};

export default Card;